/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type About_viewer$ref: FragmentReference;
export type About_viewer = {|
  +categoryAbout: ?$ReadOnlyArray<?{|
    +name: string,
    +description: string,
  |}>,
  +$refType: About_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "About_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "categoryAbout",
      "name": "categoriesShop",
      "storageKey": "categoriesShop(node:\"About\")",
      "args": [
        {
          "kind": "Literal",
          "name": "node",
          "value": "About",
          "type": "String"
        }
      ],
      "concreteType": "CategoryNode",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '23c3c9e3d032be9e567a2873513c39da';
module.exports = node;
